"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultSuccess = void 0;
const react_1 = __importDefault(require("react"));
const InlineMessage_1 = require("../../inline-message/InlineMessage");
const Heading_1 = require("../../heading/Heading");
const Paragraph_1 = require("../../paragraph/Paragraph");
const Spacer_1 = require("../../spacer/Spacer");
const ResultSuccess = () => react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Heading_1.HeadingSmall, null,
        react_1.default.createElement(InlineMessage_1.InlineMessage, { text: "Your smart prices are ready!", icon: "check", display: "success" })),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null, "Your smart pricing has been set. If your property is currently live, your new pricing will be sent to your channels shortly."),
    react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
    react_1.default.createElement(Paragraph_1.Paragraph, null, "We recommend you review your prices on the calendar, where you can override prices if required. You can disable smart pricing and restore your old prices at any time via the pricing page."));
exports.ResultSuccess = ResultSuccess;
//# sourceMappingURL=ResultSuccess.js.map